import { Loader2 } from 'lucide-react';

export default function Loader({ message = 'Aguarde...' }) {
  return (
    <div className="inset-0 z-50 flex h-full w-full flex-1 flex-col items-center justify-center gap-4">
      <Loader2 className="text-primary h-16 w-16 animate-spin" />
      <span>{message}</span>
    </div>
  );
}
